document.addEventListener('DOMContentLoaded', function(e) {
    let galleries = document.querySelectorAll('.gallery-section');

    if (galleries) {
        galleries.forEach(gallery => {
            let anchor = document.querySelector(`a[href="#${ gallery.id }"]`) || document.querySelector(`a[href="#${ gallery.id.toUpperCase() }"]`);

            anchor.addEventListener('click', function(e) {
                e.preventDefault();
                gallery.classList.add('open');
            })

            gallery.addEventListener('click', function(e) {
                if (!e.target.closest('.navigation')) {
                    gallery.classList.remove('open');
                    gallery.querySelector('.slider-wrapper').dataset.pos = 1;
                }
            })
        })
    }
})